import { useEffect, useRef } from 'react';

/**
 * Custom hook that runs an effect only once on component mount
 * Prevents duplicate API calls in React 18 StrictMode (development)
 *
 * Usage:
 * useMountEffect(() => {
 *   fetchData();
 * });
 */
export const useMountEffect = (callback) => {
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (!hasRunRef.current) {
      hasRunRef.current = true;
      callback();
    }
  }, [callback]);
};

export default useMountEffect;
